import { useContext } from 'react';
import { FormsContext } from './Context';

const useFormsContext = () => {
  const { forms, registeredForms } = useContext(FormsContext);
  return [{ data: { forms, registeredForms } }];
};

export default useFormsContext;
